import { get, post } from '@/utils/request'

// 注册 https://www.showdoc.com.cn/1281067606385943?page_id=6421961463956632
export const register = post('/sysUser/register')

// 获取图形验证码 https://www.showdoc.com.cn/1281067606385943?page_id=6457755615135004
export const sysUserGetKaptchaImage = get('/sysUser/getKaptchaImage')

// 登录 https://www.showdoc.com.cn/1281067606385943?page_id=6457569968081521
export const sysUserLogin = get('/sysUser/login')

// 区域信息树状结构 https://www.showdoc.com.cn/1281067606385943?page_id=6458546938435222
export const sysUserGetAreaTree = get('/sysUser/get/area/tree')

// 行业信息树状结构 https://www.showdoc.com.cn/1281067606385943?page_id=6458533413948227
export const sysUserGetIndustryTree = get('/sysUser/get/industry/tree')

// 发送短信 https://www.showdoc.com.cn/1281067606385943?page_id=6457746631264952
export const sysUserObtainSmscode = post('/sysUser/obtain/smscode')

// 找回密码 https://www.showdoc.com.cn/1281067606385943?page_id=6457761847443851
export const sysUserFindPwd = post('/sysUser/findPwd')

// 校验短信验证码 https://www.showdoc.com.cn/1281067606385943/7339879924696649
export const sysUserVerifySmscode = post('/sysUser/verify/smscode')

// 手机号登录 
export const sysUserPhoneLogin = post('/sysUser/smsLogin')

//修改手机号码
export const sysUserNewPhone=get('/sysUser/updateMobile')